<template>
  <v-container class="container-custom">
    <v-card class="pa-6 text-center" elevation="6" max-width="500">
      <v-card-title class="text-h5 font-weight-bold justify-center">
        Sistema de Gestión TI
      </v-card-title>

      <template v-if="esAdminTI">
        <v-btn color="light-blue" class="mb-4" block @click="$router.push('/colaboradores/listar')">
          Colaboradores
        </v-btn>

        <v-btn color="light-blue" class="mb-4" block @click="$router.push('/perifericos')">
          Periféricos
        </v-btn>

        <v-btn color="light-blue" class="mb-4" block @click="$router.push('/devices')">
          Equipos
        </v-btn>

        <v-btn color="light-blue" class="mb-4" block @click="$router.push('/dashboards')">
          Dashboards
        </v-btn>

        <v-btn color="light-blue" class="mb-4" block @click="$router.push('/logs-administrativos')">
          Logs
        </v-btn>

        <v-btn color="light-blue" class="mb-4" block @click="$router.push('/actas')">
          Actas
        </v-btn>
      </template>

      <div v-else class="mt-4">
        No tienes permisos para acceder a este módulo.
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      usuario: JSON.parse(sessionStorage.getItem("usuario") || "null"),
    };
  },
  computed: {
    esAdminTI() {
      return String(this.usuario?.rol || "").trim().toLowerCase() === "adminti";
    },
  },
};
</script>

<style scoped>
.container-custom {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
